import ContentLoader from "react-content-loader";
import { useMediaQuery } from "react-responsive";
import { Color } from "../../enums/Color";
import { merge } from "react-merge";

const styles = {
    mobile: {
        wrapper: {
            marginTop: "3.96vw"
        },
        card: {
            width: "100%",
            height: "45.5vw",
            backgroundColor: Color.White
        }
    },
    desktop: {
        wrapper: {
            marginTop: "0"
        },
        card: {
            width: "100%",
            height: "5.43vw",
            backgroundColor: Color.White
        }
    }
};


export const VacancyListLoader: React.FC = () => {
    const isMobile = useMediaQuery({ query: "(max-width: 786px)" });
    var loaderStyles = styles.mobile;
    if (!isMobile) {
        let extendStyles = merge(styles.mobile, styles.desktop);
        loaderStyles = extendStyles;
    }
    const loaderElements = new Array<any>();
    const loaderElementsCount = 10;
    for (let i = 0; i < loaderElementsCount; i++) {
        loaderElements.push(
            <div key={i} style={loaderStyles.card}>
                <ContentLoader
                    speed={1}
                    width={"100%"}
                    height={loaderStyles.card.height}
                    backgroundColor={Color.LoaderBackground}
                    foregroundColor={Color.LoaderForeground}
                >
                    {isMobile ? <>
                        <rect x="3%" y="10.3%" rx="3" ry="3" width="24.3%" height="6.25%"/>
                        <rect x="3%" y="18.3%" rx="3" ry="3" width="45.3%" height="9.5%"/>
                        <rect x="56.3%" y="18.3%" rx="3" ry="3" width="14.9%" height="9.5%"/>
                        <rect x="3%" y="31.1%" rx="3" ry="3" width="54.3%" height="5.25%"/> 
                        <rect x="78.4%" y="31.1%" rx="3" ry="3" width="17.2%" height="5.25%"/>   
                        <rect x="3%" y="42.3%" rx="3" ry="3" width="56.3%" height="5.85%"/>   
                        <rect x="3%" y="56.6%" rx="3" ry="3" width="48.2%" height="6.25%"/> 
                        <rect x="3%" y="74.6%" rx="8" ry="8" width="13.2%" height="14%"/> 
                        <rect x="18.2%" y="74.6%" rx="8" ry="8" width="13.2%" height="14%"/>  
                        <rect x="33.4%" y="74.6%" rx="8" ry="8" width="13.2%" height="14%"/>  
                        <rect x="48.6%" y="74.6%" rx="8" ry="8" width="28.4%" height="14%"/> 
                    </> :
                    <>
                        <rect x="1%" y="28.7%" rx="3" ry="3" width="16.9%" height="22%"/>
                        <rect x="1%" y="64.7%" rx="3" ry="3" width="11.3%" height="17.2%"/>
                        <rect x="18.2%" y="64.7%" rx="3" ry="3" width="3.9%" height="17.2%"/>
                        <rect x="24.9%" y="64.7%" rx="3" ry="3" width="4.6%" height="17.2%"/>
                        <rect x="51.3%" y="30.7%" rx="8" ry="8" width="4.2%" height="27.2%"/>
                        <rect x="64.8%" y="30.7%" rx="3" ry="3" width="5.9%" height="18.2%"/>
                        <rect x="66.8%" y="54.9%" rx="3" ry="3" width="13.2%" height="18.2%"/>
                        <rect x="90.4%" y="30.7%" rx="3" ry="3" width="8.7%" height="18.2%"/>
                        <rect x="90.8%" y="54.9%" rx="3" ry="3" width="8.2%" height="18.2%"/>
                    </>}                     
                </ContentLoader>
            </div>
        )
    }
    
    return (
        <div style={loaderStyles.wrapper}>
            {loaderElements}
        </div>
    );
}